<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">

        <div class="product-content">
          <el-form ref="form" :model="form" label-width="100px">
            <div class="table-wrap">
              <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          
                <el-table-column prop="user.nickName" label="用户名"></el-table-column>
                <el-table-column prop="id_card_front" label="身份证正面" width="100">
                  <template slot-scope="scope">
                    <div v-if="scope.row.id_card_front" class="img-box">
                      <el-image
                        :src="scope.row.id_card_front"
                        :preview-src-list="[scope.row.id_card_front]"
                        style="width: 80px; height: 60px; object-fit: cover; cursor: pointer;"
                      ></el-image>
                    </div>
                    <div v-else>-</div>
                  </template>
                </el-table-column>
                <el-table-column prop="id_card_back" label="身份证背面" width="100">
                  <template slot-scope="scope">
                    <div v-if="scope.row.id_card_back" class="img-box">
                      <el-image
                        :src="scope.row.id_card_back"
                        :preview-src-list="[scope.row.id_card_back]"
                        style="width: 80px; height: 60px; object-fit: cover; cursor: pointer;"
                      ></el-image>
                    </div>
                    <div v-else>-</div>
                  </template>
                </el-table-column>
                <el-table-column prop="certificates" label="其他资质" width="100">
                  <template slot-scope="scope">
                    <div v-if="scope.row.certificates" class="img-box">
                      <el-image
                        :src="scope.row.certificates"
                        :preview-src-list="[scope.row.certificates]"
                        style="width: 80px; height: 60px; object-fit: cover; cursor: pointer;"
                      ></el-image>
                    </div>
                    <div v-else>-</div>
                  </template>
                </el-table-column>
                <el-table-column prop="service_type" label="服务类型">
                  <template slot-scope="scope">
                    <span> {{ scope.row.service_type }}</span>
                  </template>
                </el-table-column> 
                <!-- <el-table-column prop="address" label="服务区域"></el-table-column>
                <el-table-column prop="service_range" label="服务范围"></el-table-column> -->
                <el-table-column prop="status" label="状态" width="100">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.status === 0" type="info">未审核</el-tag>
                    <el-tag v-else-if="scope.row.status === 1" type="success">已通过</el-tag>
                    <el-tag v-else-if="scope.row.status === 2" type="danger">未通过</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.status === 0" @click="auditClick(scope.row)" type="primary" size="small" style="margin-right: 5px;">审核</el-button>
                    <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form>
          <!--分页-->
          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              background
              :current-page="curPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, jumper"
              :total="totalDataNumber"
            ></el-pagination>
          </div>
        </div>
    </div>  
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :service_apply_id="service_apply_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
    
    <!-- 审核对话框 -->
    <el-dialog title="审核" :visible.sync="auditDialogVisible" @close='closeAuditDialog' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
      <div style="text-align: left; margin-bottom: 20px;">
        <p>用户：{{ auditRow && auditRow.user && auditRow.user.nickName }}</p>
        <p>服务类型：{{ auditRow && auditRow.service_type?auditRow.service_type:'' }}</p>
        <p>服务区域：{{ auditRow && auditRow.address }}</p>
      </div>
      <div style="text-align: center;">
        <el-button @click="closeAuditDialog">取消</el-button>
        <el-button type="danger" @click="auditReject" style="margin-left: 10px;">审核不通过</el-button>
        <el-button type="primary" @click="auditPass" style="margin-left: 10px;">审核通过</el-button>
      </div>
    </el-dialog>
  

  </div>
</template>

<script>
  import Service_applyApi from '@/api/service_apply.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        service_apply_id:"",
        dialogVisible:false,
        /*审核相关*/
        auditDialogVisible: false,
        auditRow: null,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//服务者入驻标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Service_applyApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.service_apply_id = row.service_apply_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Service_applyApi.del(
              {
                service_apply_id: row.service_apply_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
      
      /*打开审核对话框*/
      auditClick(row) {
        this.auditRow = row;
        this.auditDialogVisible = true;
      },
      
      /*关闭审核对话框*/
      closeAuditDialog() {
        this.auditDialogVisible = false;
        this.auditRow = null;
      },
      
      /*审核通过*/
      auditPass() {
        let self = this;
        if (!self.auditRow) return;
        
        Service_applyApi.audit(
          {
            service_apply_id: self.auditRow.service_apply_id,
            status: 1
          },
          true
        )
          .then(data => {
            if (data.code == 1) {
              self.$message({
                message: '审核通过',
                type: 'success'
              });
              self.closeAuditDialog();
              self.getTableList();
            } else {
              self.$message.error('错了哦，这是一条错误消息');
            }
          })
          .catch(error => {
          });
      },
      
      /*审核不通过*/
      auditReject() {
        let self = this;
        if (!self.auditRow) return;
        
        Service_applyApi.audit(
          {
            service_apply_id: self.auditRow.service_apply_id,
            status: 2
          },
          true
        )
          .then(data => {
            if (data.code == 1) {
              self.$message({
                message: '审核不通过',
                type: 'success'
              });
              self.closeAuditDialog();
              self.getTableList();
            } else {
              self.$message.error('错了哦，这是一条错误消息');
            }
          })
          .catch(error => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/service_apply/index/index.vue